import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import cargandoCard from "../../components/cargando-card";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_LISTAR_ATRAS, ESTILO_INPUT_GENERICO, ESTILO_SECCION_BOTON_DOWN } from "../../utils/const/estilos-const";
import Select from "react-select";
import { ArrowDownCircle, ArrowUpCircle } from "feather-icons-react/build/IconComponents";
import SwitchComponent from "../../components/switch";
import shortid from "shortid";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../components/processing-dialog";
import ToastComponent from "../../components/toast-component";
import { deshabilitarViajeChecklist, guardarViajeChecklist, habilitarViajeChecklist, intercambiarPosicionViajeChecklist, obtenerViajeChecklist } from "../../api/api-viaje-checklist";
import { useSelectViajeChecklist } from "./const-select-viaje-checklist";

export default function ViajeChecklistScreen() {
    const history = useHistory();
    const location = useLocation();
    const { t } = useTranslation();
    const SELECT_VIAJE_CHECKLIST = useSelectViajeChecklist();
    const [cargandoPage, setCargandoPage] = useState(true);
    const [inputFormularioSelected, setInputFormularioSelected] = useState(null);
    const [listaInputs, setListaInputs] = useState([]);
    const [idChecklist, setIdChecklist] = useState(null);
    const [nombreChecklist, setNombreChecklist] = useState("");

    const [processingVisible, setProcessingVisible] = useState(false);
    const [toastVisible, setToastVisible] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const data = location.state;
            // console.log("data");
            // console.log(data);
            setIdChecklist(data.idChecklist);
            setNombreChecklist(data.nombre);
            let objEnviar = {};
            objEnviar.idChecklist = data.idChecklist;
            const repsonseViajeChecklist = await obtenerViajeChecklist(objEnviar);
            // console.log("repsonseViajeChecklist");
            // console.log(repsonseViajeChecklist);
            if (repsonseViajeChecklist.length > 0) {
                let lista = [];
                for (let i = 0; i < repsonseViajeChecklist.length; i++) {
                    const element = repsonseViajeChecklist[i];
                    let obj = {
                        id: element.id,
                        idChecklist: data.id,
                        idConcepto: element.idConcepto,
                        value: element.idConcepto,
                        label: element.concepto,
                        habilitado: element.habilitado,
                        orden: element.orden,
                    };
                    lista.push(obj);
                }
                setListaInputs(lista);
            }
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        } finally {
            setCargandoPage(false);
        }
    };

    const showToast = (message, type = "warning", durationMs = 3000) => {
        setToastMessage(message);
        setToastType(type);
        setToastVisible(true);
        // Auto-hide
        window.clearTimeout(showToast._timer);
        showToast._timer = window.setTimeout(() => {
            setToastVisible(false);
        }, durationMs);
    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const handleAgregarClick = async () => {
        // console.log('handleAgregarClick');
        if (inputFormularioSelected === null) {
            return;
        }
        // console.log('inputFormularioSelected');
        // console.log(inputFormularioSelected);
        const existe = listaInputs.find(e => e.value === inputFormularioSelected.value);
        // console.log('existe');
        // console.log(existe);
        if (existe === undefined) {
            let newInput = {
                idChecklist: idChecklist,
                idConcepto: inputFormularioSelected.value,
                value: inputFormularioSelected.value,
                label: inputFormularioSelected.label,
                habilitado: true,
                orden: listaInputs.length,
            };
            setProcessingVisible(true);
            const resp = await guardarViajeChecklist(newInput);
            setProcessingVisible(false);
            // console.log('guardoNuevo');
            // console.log(guardoNuevo);
            if (resp.error === false) {
                newInput.id = resp.id;
                setListaInputs([...listaInputs, newInput]);
                reset();
            }
        }
        if (existe !== undefined) {
            alert(t('alert_este_tipo_de_input_ya_existe'));
        }
    };

    const renderListInputs = () => {
        try {
            // console.log('renderListInputs');
            // console.log(listaInputs);
            return (
                <>
                    {listaInputs.map((input, index) => (
                        <>
                            <div key={shortid.generate()} className="flex flex-column">
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        width: '100%',
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '40%'
                                        }}
                                    >
                                        <label key={input.id} className="font-bold">
                                            {t('label_tipo_input')}:
                                        </label>
                                        <li>{input.label}</li>
                                        <input
                                            type="text"
                                            className={ESTILO_INPUT_GENERICO}
                                            maxLength={255}
                                            placeholder={t('label_ejemplo')}
                                            readOnly
                                        />
                                    </div>
                                    <div
                                        style={{
                                            width: '10%'
                                        }}
                                    >
                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            width: '30%',
                                            alignItems: 'center',
                                        }}
                                    >
                                        {index > 0 && <button
                                            type="button"
                                            className={ESTILO_SECCION_BOTON_DOWN}
                                            onClick={() => { moverSeccionUpClick(index); }}
                                            title={t('label_mover_input_arriba')}
                                        >
                                            <ArrowUpCircle />
                                        </button>}

                                        {index < listaInputs.length - 1 &&
                                            <button
                                                type="button"
                                                className={ESTILO_SECCION_BOTON_DOWN}
                                                onClick={() => { moverSeccionDownClick(index); }}
                                                title={t('label_mover_input_abajo')}
                                            >
                                                <ArrowDownCircle />
                                            </button>}

                                    </div>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            width: '20%',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <SwitchComponent isOn={input.habilitado} handleToggle={() => { handleToggle(input, index); }} />
                                        <p className="ml-4" >{input.habilitado ? t('label_activo') : t('label_no_activo')}</p>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <hr />
                            <br />
                        </>
                    ))}
                </>
            );
        } catch (err) {
            console.log('render err renderListInputs');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    };

    const handleToggle = async (input) => {
        try {
            // console.log('handleToggle');
            // console.log(input);
            // console.log(index);
            if (input.habilitado === 1 || input.habilitado === true) {
                const deshabilitado = await deshabilitarViajeChecklist(input);
                if (deshabilitado === true) {
                    alert(t('alert_se_proceso_correctamente'));
                    reset();
                }
            }
            if (input.habilitado === 0 || input.habilitado === false) {
                const habilito = await habilitarViajeChecklist(input);
                if (habilito === true) {
                    alert(t('alert_se_proceso_correctamente'));
                    reset();
                }
            }
        } catch (err) {
            console.log('handleToggle err');
            console.log(err);
        }
    };

    const moverSeccionUpClick = async (index) => {
        // console.log('moverSeccionUpClick');
        // console.log(index);
        if (index === 0) return; // No mover si es el primer elemento
        let objEnviar = {};
        objEnviar.objetoA = listaInputs[index];
        objEnviar.objetoB = listaInputs[index - 1];
        const intercambiar = await intercambiarPosicionViajeChecklist(objEnviar);
        if (intercambiar === true) {
            reset();
        }
        if (intercambiar === false) {
            alert(t('alert_no_se_pudo_procesar'));
        }
    };

    const moverSeccionDownClick = async (index) => {
        // console.log('moverSeccionDownClick');
        // console.log(index);
        if (index === listaInputs.length - 1) return; // No mover si es el último elemento
        let objEnviar = {};
        objEnviar.objetoA = listaInputs[index];
        objEnviar.objetoB = listaInputs[index + 1];
        const intercambiar = await intercambiarPosicionViajeChecklist(objEnviar);
        if (intercambiar === true) {
            reset();
        }
        if (intercambiar === false) {
            alert(t('alert_no_se_pudo_procesar'));
        }
    };

    const reset = () => {
        setCargandoPage(true);
        iniciar();
    };

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            return (
                <div className="pt-4 px-4 " >
                    <div className="flex justify-between">
                        <div className="flex justify-center align-center">
                            <label
                                style={{
                                    paddingLeft: 10,
                                    fontWeight: 'bold',
                                }}
                            >
                                {t('titulo_viaje_checklist')}: {nombreChecklist}
                            </label>
                        </div>
                        <div className="flex justify-center">
                            <button
                                type="button"
                                className={ESTILO_BOTON_LISTAR_ATRAS}
                                onClick={handleAtrasClick}
                            >
                                {t('btn_atras')}
                            </button>
                        </div>
                    </div>
                    <hr />
                    <br />
                    <div class="grid grid-cols-12 gap-4">
                        <div class="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                            <label className="font-bold">{t('label_seleccione_input')}</label>
                            <div
                                className="flex"
                            >
                                <Select
                                    options={SELECT_VIAJE_CHECKLIST}
                                    isSearchable={true}
                                    isClearable={true}
                                    value={inputFormularioSelected}
                                    onChange={(e) => {
                                        setInputFormularioSelected(e);
                                    }}
                                    placeholder={t('label_seleccione_input')}
                                    styles={{
                                        container: (provided) => ({
                                            ...provided,
                                            width: '350px' // Set your desired width here
                                        })
                                    }}
                                />
                                <div
                                    className={ESTILO_BOTON_GENERAL_ACEPTAR}
                                    style={{ marginRight: '16px' }}
                                >
                                    <button
                                        type="button"
                                        onClick={handleAgregarClick}
                                    >
                                        {t('btn_agregar')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <hr />
                    {renderListInputs()}
                    <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
                    <ToastComponent
                        visible={toastVisible}
                        message={toastMessage}
                        type={toastType}
                        onClose={() => setToastVisible(false)}
                    />
                </div>
            );
        } catch (err) {
            console.log('render err ChecklistScreen');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    };

    return render();
}